<template>
  <div
    class="sofia-chat-demo"
    aria-label="Demostración de conversación con Agente Sofía"
  >
    <div class="phone-glow" aria-hidden="true"></div>

    <div class="phone-shell">
      <header class="phone-header">
        <i class="fas fa-arrow-left header-back" aria-hidden="true"></i>
        <div class="sofia-avatar">S</div>
        <div class="header-copy">
          <strong>Agente Sofía</strong>
          <span><i class="online-dot"></i> En línea</span>
        </div>
        <i class="fas fa-ellipsis-v header-menu" aria-hidden="true"></i>
      </header>

      <div ref="messages" class="chat-area" aria-live="polite">
        <transition-group name="message" tag="div" class="message-list">
          <article
            v-for="message in visibleMessages"
            :key="message.id"
            class="message-bubble"
            :class="message.type"
          >
            <p>{{ message.text }}</p>
            <time>{{ message.time }}</time>
          </article>
        </transition-group>

        <transition name="message">
          <div
            v-if="typing"
            class="typing-bubble"
            aria-label="Sofía está escribiendo"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </transition>
      </div>

      <footer class="phone-input">
        <button type="button" tabindex="-1" aria-label="Agregar archivo">
          <i class="fas fa-plus"></i>
        </button>
        <div class="input-placeholder">Escribe un mensaje...</div>
        <button
          type="button"
          class="microphone"
          tabindex="-1"
          aria-label="Mensaje de voz"
        >
          <i class="fas fa-microphone"></i>
        </button>
      </footer>
    </div>

    <div class="phone-shadow" aria-hidden="true"></div>
  </div>
</template>

<script>
const CHAT_MESSAGES = [
  {
    id: 1,
    type: "outgoing",
    text: "Hola.",
    time: "08:18 a.m.",
  },
  {
    id: 2,
    type: "incoming",
    text: "¡Hola! 😊. Soy Sofía, tu asistente. ¿Buscamos agendar una cita o necesitas información de algún servicio o prodcuto?",
    time: "08:18 a.m.",
  },
  {
    id: 3,
    type: "outgoing",
    text: "Necesito Información",
    time: "08:19 a.m.",
  },
  {
    id: 4,
    type: "incoming",
    text: "¡Claro! 😊 ¿Qué información necesitas: agendar una cita o consultar sobre algún servicio o producto en específico?",
    time: "08:19 a.m.",
  },
  {
    id: 5,
    type: "outgoing",
    text: "Examen general, qué precio?",
    time: "08:20 a.m.",
  },
  {
    id: 6,
    type: "incoming",
    text: "¡Perfecto! Para el examen general te ofrecemos la Consulta (30 min) por un costo de ... ",
    time: "08:20 a.m.",
  },
];

export default {
  name: "SofiaChatDemo",

  data() {
    return {
      visibleMessages: [],
      typing: false,
      timers: [],
      reducedMotion: false,
    };
  },

  mounted() {
    this.reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    this.startConversation();
  },

  beforeDestroy() {
    this.clearTimers();
  },

  methods: {
    schedule(callback, delay) {
      const timer = window.setTimeout(callback, delay);
      this.timers.push(timer);
    },

    clearTimers() {
      this.timers.forEach((timer) => window.clearTimeout(timer));
      this.timers = [];
    },

    scrollToLatest() {
      this.$nextTick(() => {
        const container = this.$refs.messages;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    startConversation() {
      this.clearTimers();
      this.visibleMessages = [];
      this.typing = false;

      if (this.reducedMotion) {
        this.visibleMessages = CHAT_MESSAGES;
        this.scrollToLatest();
        return;
      }

      let elapsed = 650;

      CHAT_MESSAGES.forEach((message) => {
        const isIncoming = message.type === "incoming";

        if (isIncoming) {
          this.schedule(() => {
            this.typing = true;
            this.scrollToLatest();
          }, elapsed);
          elapsed += 900;
        }

        this.schedule(() => {
          this.typing = false;
          this.visibleMessages.push(message);
          this.scrollToLatest();
        }, elapsed);

        elapsed += isIncoming ? 1350 : 1100;
      });

      this.schedule(() => this.startConversation(), elapsed + 3500);
    },
  },
};
</script>

<style scoped>
.sofia-chat-demo {
  position: relative;
  width: min(100%, 370px);
  margin: 0 auto;
  padding: 22px 18px 0;
  animation: phone-float 6s ease-in-out infinite;
  isolation: isolate;
}

.phone-glow {
  position: absolute;
  z-index: -1;
  inset: 12% -20% 5%;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(40, 169, 224, 0.34) 0%,
    rgba(10, 74, 159, 0.12) 45%,
    transparent 72%
  );
  filter: blur(34px);
}

.phone-shell {
  height: min(650px, 72vh);
  min-height: 540px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 8px solid #344258;
  border-radius: 42px;
  background: #0f1b30;
  box-shadow: 0 35px 80px rgba(0, 6, 22, 0.55),
    inset 0 0 0 1px rgba(255, 255, 255, 0.05);
}

.phone-header {
  min-height: 74px;
  padding: 12px 17px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #344258;
}

.header-back,
.header-menu {
  color: #d7dfeb;
  font-size: 17px;
}

.header-menu {
  margin-left: auto;
}

.sofia-avatar {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  background: linear-gradient(145deg, #28a9e0, #1874cf);
  box-shadow: 0 8px 20px rgba(40, 169, 224, 0.25);
}

.header-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.header-copy strong {
  color: #fff;
  font-family: "Courier New", monospace;
  font-size: 13px;
  letter-spacing: 0.08em;
}

.header-copy span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #2de078;
  font-size: 11px;
}

.online-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 0 4px rgba(45, 224, 120, 0.12);
  animation: online-pulse 2s ease infinite;
}

.chat-area {
  flex: 1;
  min-height: 0;
  padding: 16px 15px;
  overflow-y: auto;
  scroll-behavior: smooth;
  background-color: #0d1930;
  background-image: radial-gradient(
    rgba(255, 255, 255, 0.065) 1px,
    transparent 1px
  );
  background-size: 20px 20px;
  scrollbar-width: none;
}

.chat-area::-webkit-scrollbar {
  display: none;
}

.message-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.message-bubble {
  width: fit-content;
  max-width: 82%;
  padding: 12px 13px 8px;
  border-radius: 13px;
  color: #fff;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.14);
}

.message-bubble.incoming {
  align-self: flex-start;
  border-top-left-radius: 3px;
  background: #344258;
}

.message-bubble.outgoing {
  align-self: flex-end;
  border-top-right-radius: 3px;
  background: linear-gradient(145deg, #2686d7, #1d74bd);
}

.message-bubble p {
  margin: 0;
  color: inherit;
  font-size: 13px;
  line-height: 1.42;
}

.message-bubble time {
  display: block;
  margin-top: 5px;
  color: rgba(255, 255, 255, 0.66);
  font-size: 9px;
  line-height: 1;
  text-align: right;
}

.typing-bubble {
  width: 58px;
  margin-top: 14px;
  padding: 13px;
  display: flex;
  justify-content: center;
  gap: 5px;
  border-radius: 13px 13px 13px 3px;
  background: #344258;
}

.typing-bubble span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #afbdd1;
  animation: typing-dot 1.2s ease-in-out infinite;
}

.typing-bubble span:nth-child(2) {
  animation-delay: 0.16s;
}

.typing-bubble span:nth-child(3) {
  animation-delay: 0.32s;
}

.phone-input {
  min-height: 60px;
  padding: 9px 13px;
  display: flex;
  align-items: center;
  gap: 9px;
  background: #344258;
}

.phone-input button {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  padding: 0;
  border: 0;
  display: grid;
  place-items: center;
  color: #d3ddeb;
  background: transparent;
  cursor: default;
}

.input-placeholder {
  flex: 1;
  min-width: 0;
  height: 39px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  border-radius: 22px;
  color: #c7d0de;
  background: #1d2940;
  font-size: 12px;
}

.phone-input .microphone {
  width: 39px;
  height: 39px;
  flex-basis: 39px;
  border-radius: 50%;
  color: #fff;
  background: #25d366;
  box-shadow: 0 8px 18px rgba(37, 211, 102, 0.24);
}

.phone-shadow {
  width: 78%;
  height: 22px;
  margin: 20px auto 0;
  border-radius: 50%;
  background: rgba(0, 5, 20, 0.48);
  filter: blur(12px);
}

.message-enter-active,
.message-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.message-enter,
.message-leave-to {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}

@keyframes phone-float {
  0%,
  100% {
    transform: translateY(0) rotate(-0.3deg);
  }
  50% {
    transform: translateY(-14px) rotate(0.3deg);
  }
}

@keyframes typing-dot {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.55;
  }
  30% {
    transform: translateY(-5px);
    opacity: 1;
  }
}

@keyframes online-pulse {
  50% {
    box-shadow: 0 0 0 7px rgba(45, 224, 120, 0);
  }
}

@media (max-width: 767px) {
  .sofia-chat-demo {
    width: min(100%, 330px);
    padding-inline: 8px;
  }

  .phone-shell {
    height: 570px;
    min-height: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sofia-chat-demo,
  .online-dot,
  .typing-bubble span {
    animation: none;
  }

  .message-enter-active,
  .message-leave-active {
    transition: none;
  }
}
</style>
